import React, { useEffect, useState } from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { TextField } from '@mui/material'

import ElementContainer from '../ElementContainer'

export default function DateTimeElement ({
  title,
  helpfulHint,
  isMandatory,
  answer,
  onChangeValue,
  isPreviewMode,
  disabled
}) {
  const [value, setValue] = useState(answer)
  useEffect(() => {
    setValue(answer)
  }, [answer])

  function handleChangeValue (event) {
    const value = event.target.value
    setValue(value)
    onChangeValue(value)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ElementContainer
        title={title}
        helpfulHint={helpfulHint}
        isMandatory={isMandatory}
      >
        <TextField
          disabled={disabled}
          fullWidth
          value={value}
          onChange={handleChangeValue}
          id="date"
          variant="standard"
          type="date"
          // note for some reason this style do not work as a class
          InputProps={{
            disableUnderline: true,
            inputProps: {
              style: {
                textAlign: 'left',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '14px',
                marginLeft: '5px',
                '&::-webkit-calendar-picker-indicator': {
                  display: 'none',
                  '-webkit-appearance': 'none'
                }
              }
            }
          }}
        />
      </ElementContainer>
    </LocalizationProvider>
  )
}
